export default {"src":"/_next/static/media/logo-sequoia-capital-vector-white.6781ef75.svg","height":79,"width":600,"blurWidth":0,"blurHeight":0};